<mat-label class="subHeading">Coverage Type<span *ngIf="isRequired" class="star">*</span></mat-label>
<mat-select multiple formControlName="coverage_type" class="coverage" placeholder="{{isRequired ? 'Select' : 'All'}}">
    <mat-option (onSelectionChange)="selectionChange($event)" [value]="0">Comprehensive</mat-option>
    <mat-option (onSelectionChange)="selectionChange($event)" [value]="1">Third Party</mat-option>
    <mat-option (onSelectionChange)="selectionChange($event)" *ngIf="lob != 'cv'" [value]="2">Own Damage</mat-option>
</mat-select>